import { render, staticRenderFns } from "./E-ChannelReport.vue?vue&type=template&id=2910fbe0&scoped=true&"
import script from "./E-ChannelReport.vue?vue&type=script&lang=js&"
export * from "./E-ChannelReport.vue?vue&type=script&lang=js&"
import style0 from "./E-ChannelReport.vue?vue&type=style&index=0&id=2910fbe0&lang=scss&scoped=true&"
import style1 from "./E-ChannelReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2910fbe0",
  null
  
)

export default component.exports